import {Card, Col, Container, Row, Image, Button} from "react-bootstrap";
import SkillsList from "./SkillsList";
import {Avatar} from "@nextui-org/react";
const Introduction = (props: { scrollToSection: any }) => {
  return (
    <div style={{
      backgroundColor: 'aliceblue',
      height: "80vh",
    }}>
      <Row style={{height: "100%"}}>
        <Col sm={12} md={6}
             style={{
               display: "flex",
               margin: "auto",
               justifyContent: "center",
               alignItems: "center"
             }}>
            <Avatar
              src={require('../assets/images/avatar4.png')}
              color="primary"
              bordered
              borderWeight='extrabold'
              css={{ size: "300px" }}
            />
        </Col>
        <Col sm={12} md={6} style={{
          display: "flex",
          flexDirection:"column",
          margin: "auto",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center"
        }}>
          <h1>Hi There! I'm Nam Nguyen</h1>
          <p style={{textAlign:'center'}}>
            I am an enthusiatic software engineer based in Houston, Texas
          </p>
          <div style={{display: 'flex', alignItems: "center", justifyContent: 'center'}}>
            <SkillsList/>
          </div>
          <div style={{marginTop: 10}}>
            <button className="btn" onClick={() => {
              window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: 'smooth'
              })
            }
            }>Contact Me
            </button>
            <button className="btn" onClick={() => {
              props.scrollToSection();
            }
            }>My Projects
            </button>
          </div>

        </Col>
      </Row>
    </div>
  )
}

export default Introduction;